import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

const { spaces, colors } = getBaseTheme();

export const SelectableText = styled.p({
    margin: 0,
    padding: '0.6rem' // padding needs to be hardcoded to o.6rem to be able to get number of lines right
});

export const SelectableActionsContainer = styled.div({
    display: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 2,
    padding: `${spaces.inline.xxxs} ${spaces.inline.xxs}`,
    backgroundColor: `${colors.area.default.backgroundColor}`,
    borderColor: `${colors.area.default.strokeColor}`,
    borderWidth: '1px',
    borderStyle: 'solid'
});

export const SelectableTextContainer = styled.div({
    width: '100%',
    display: 'block',
    borderColor: `transparent`,
    borderWidth: '1px',
    borderStyle: 'solid',
    marginBottom: `${spaces.default.xs}`,
    '&:focus': {
        outline: 'none',
        borderRadius: '5px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: `${colors.area.default.complementaryStrokeColor}`,
        backgroundColor: `${colors.area.active.backgroundColor}`,
        cursor: 'text',
        [`> ${SelectableActionsContainer}`]: {
            display: 'flex'
        }
    },
    '&:hover': {
        backgroundColor: `${colors.area.hover.backgroundColor}`,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: `${colors.area.default.strokeColor}`,
        cursor: 'pointer',
        [`> ${SelectableActionsContainer}`]: {
            display: 'flex'
        }
    },
    '&:focus:hover': {
        borderRadius: '5px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: `${colors.area.default.complementaryStrokeColor}`,
        backgroundColor: `${colors.area.active.backgroundColor}`,
        cursor: 'text',
        [`> ${SelectableActionsContainer}`]: {
            display: 'flex'
        }
    }
});

export const SelectableContainer = styled.div({
    position: 'relative'
});
